<template>
  <el-dialog
    title="兑换优惠券"
    :visible.sync="dialogCouponVisible"
    :close-on-click-modal="false"
    width="30%"
    @close="handleClose"
  >
    <el-row type="flex" justify="center">
      <el-col :sm="24" :lg="18">
        <el-form
          ref="couponForm"
          :rules="couponRules"
          :model="couponForm"
          label-position="left"
          label-width="120px"
        >
          <el-form-item label="优惠券兑换码" prop="code">
            <el-input v-model="couponForm.code" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCouponVisible = false"> 取消 </el-button>
      <el-button type="primary" @click="handleConfirm"> 确认 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { couponsService } from "@/api/coupons";

export default {
  name: "Coupon",
  props: {
    dialogCouponVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      couponForm: {
        code: "",
      },
      couponRules: {
        code: [
          { required: true, message: "请输入优惠券兑换码", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    handleClose() {
      this.couponForm.code = ""; // 清空兑换码
      this.$emit("update:dialogCouponVisible", false);
    },
    handleConfirm() {
      // this.$emit("update:dialogCouponVisible", false);
      this.$refs.couponForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 调用兑换优惠券的API
          // this.$emit("confirm", this.couponForm.code);

          couponsService.redeemCoupon(this.couponForm.code).then((response) => {
            this.$emit("event", response); // 传递兑换的优惠券信息
          });

          this.loading = false;
          this.handleClose();
        } else {
          this.$message.error("请填写正确的兑换码");
        }
      });
    },
  },
};
</script>

<style scoped></style>
